import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const OrderLot: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Order Lot',
  minWidth: 45,
  accessorFn: (product) => product.order_lot,
  gloss:
    'Whether you order by the case (C) or by the unit (U). When set to C, Orderbot blocks unit-quantity orders.',
});
